import { useState } from "react";
import { useTranslation } from "react-i18next";
import { InvoiceTable } from "@/components/backOffice/invoices/invoicesTab/invoiceTable";
import { DisplayTypeSelectBo } from "@/components/backOffice/clients/invoices/displayTypeSelectBo";
import { LitigeTable } from "@/components/backOffice/invoices/litigesTab/litigeTable";
import { InvoiceToBeValidatedTable } from "@/components/backOffice/invoices/invoicesToBeValidatedTab/invoiceToBeValidatedTable";
import { TrashIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DeletedInvoiceTable } from "@/components/backOffice/invoices/deletedTab/deletedInvoiceTable";
import { DisplayType } from "@/types/invoiceDisplayTypes";
import { BlockedInvoiceTable } from "@/components/backOffice/invoices/blockedTab/bockedInvoiceTable";

export const InvoicesBoPage = () => {
  const { t } = useTranslation("boInvoices");
  const [displayType, setDisplayType] = useState<DisplayType>("invoice");

  return (
    <div className="flex h-fit w-full flex-1 flex-col gap-4 p-8">
      <div className="flex w-full flex-col gap-2">
        <h1 className="font-jakarta-sans text-3xl font-semibold">{t("page.title")}</h1>
        <p>{t("page.subtitle")}</p>
      </div>
      <div className="flex flex-1 flex-col gap-6">
        <div className="flex w-full flex-row justify-between">
          <DisplayTypeSelectBo
            setDisplayType={setDisplayType}
            displayType={displayType}
            counter={true}
          />
          <Button variant="ghost" onClick={() => setDisplayType("deleted")}>
            <TrashIcon />
          </Button>
        </div>
        {displayType === "invoice" ? (
          <InvoiceTable />
        ) : displayType === "litige" ? (
          <LitigeTable />
        ) : displayType === "invoiceToBeValidated" ? (
          <InvoiceToBeValidatedTable />
        ) : displayType === "deleted" ? (
          <DeletedInvoiceTable />
        ) : displayType === "invoiceBlocked" ? (
          <BlockedInvoiceTable />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
